import { useState } from "react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { DeedFields, navyBtn } from "@/components/NextStep";

// «Indicar hora e local» da escritura ou do CPCV (ação urgente do painel da gestora).
export function HoraLocalDialog({ r, onClose, onSaved }) {
  const [time, setTime] = useState(r.hl_time || "");
  const [place, setPlace] = useState(r.hl_place || "");
  const pre = r.hl === "CPCV" ? "cpcv" : "deed";
  const save = async () => {
    try {
      await api.put(`/processes/${r.pid}`, { [`${pre}_time`]: time || null, [`${pre}_place`]: place.trim() || null });
      toast.success("Hora e local guardados");
      onSaved();
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm space-y-2" data-testid="hora-local-dialog">
        <DialogHeader><DialogTitle className="font-heading navy-text">{r.hl === "CPCV" ? "Hora e local do CPCV" : "Hora e local da escritura"}</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-500">{r.short} · {r.when}</p>
        <DeedFields time={time} setTime={setTime} place={place} setPlace={setPlace} />
        <button disabled={!time || !place.trim()} onClick={save} className={navyBtn} data-testid="hora-local-save">Guardar</button>
      </DialogContent>
    </Dialog>
  );
}
